import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"
import { Download } from "lucide-react"

const ImportManualDialog = ({ isOpen, onClose }) => {
  const downloadSampleFile = () => {
    const templateUrl = '/templates/sample_student.csv'
    window.location.href = templateUrl
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader className="px-6 pt-6 pb-2">
          <DialogTitle>How to Import Students</DialogTitle>
        </DialogHeader>
        <div className="px-6 pb-6 overflow-y-auto flex-1">
          <div className="space-y-4">
            <p>Please follow these guidelines to ensure successful import:</p>

            <div className="bg-amber-50 border-l-4 border-amber-500 p-4 text-amber-700">
              <h3 className="font-bold">Required Format</h3>
              <p>Upload a CSV or Excel file with the following columns:</p>
            </div>

            <div className="overflow-x-auto">
              <Table className="w-full">
                <TableHeader>
                  <TableRow>
                    <TableHead className="w-1/4">Column Name</TableHead>
                    <TableHead className="w-1/4">Required</TableHead>
                    <TableHead className="w-2/4">Description</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody className="text-sm">
                  <TableRow>
                    <TableCell className="font-medium">firstName</TableCell>
                    <TableCell>Yes</TableCell>
                    <TableCell>Student's first name</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">middleName</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Student's middle name</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">lastName</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Student's last name</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">email</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Student's email address (optional)</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">phoneNumber</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Student's phone number (10 digits, optional)</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">admissionNumber</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Student's admission number</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">aadhaarCard</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Student's Aadhaar card number (optional)</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">class</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Class name or ID</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">section</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Section name</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">rollNumber</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Student's roll number (optional)</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">birthday</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Date of birth (dd/mm/yyyy format, e.g., 25/12/2000)</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">bloodGroup</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Blood group (A+, A-, B+, B-, AB+, AB-, O+, O-, Unknown). Spaces are automatically removed (e.g., "A +" becomes "A+")</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">fatherName</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Father's name</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">fatherContactNumber</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Father's contact number</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">motherName</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Mother's name</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">motherContactNumber</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Mother's contact number</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">gender</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Gender (Male, Female, Other). Case-insensitive - spaces are automatically removed</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">transportationType</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Transportation type (bus, van, self). Case-insensitive</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">guardianName</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Guardian's name</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">guardianContactNumber</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Guardian's contact number</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">address_street</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Street address</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">address_city</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>City</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">address_state</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>State</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">address_pincode</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Pincode/ZIP code</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium">address_country</TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Country (default: India)</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 text-blue-700">
              <h3 className="font-bold">Notes:</h3>
              <ul className="list-disc pl-5 space-y-1 mt-2">
                <li>The system will automatically generate usernames and passwords</li>
                <li>All users will be assigned to the current academic year</li>
                <li>Only <strong>firstName</strong> is required. All other fields are optional</li>
                <li>Email, phone number, roll number, class, and section are optional</li>
                <li>Birthday format: Use <strong>dd/mm/yyyy</strong> (e.g., 25/12/2000)</li>
                <li>Blood group: Spaces are automatically removed (e.g., "A +" becomes "A+")</li>
                <li>Gender: Case-insensitive (male/Male both work), spaces are removed</li>
                <li>Transportation type: Case-insensitive (bus/Bus/BUS all work)</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="flex justify-end space-x-2 px-6 py-4 border-t">
          <Button variant="outline" onClick={downloadSampleFile}>
            <Download className="h-4 w-4 mr-2" />
            Download Template
          </Button>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
          <Button
            onClick={() => {
              document.getElementById("file-upload").click()
              onClose()
            }}
          >
            Proceed to Import
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ImportManualDialog
